<template>
  <div>
    <!-- 顶部图片 -->
    <div class="bgimage">
      <img src="../assets/cover.png" alt="" width="100%" class="hp" />
    </div>
    <div class="content">
      <!-- 中英文景点名 -->
      <div class="name">
        <div class="name1">上海气象博物馆</div>
        <div class="name2">Shanghai Meteorological Museum</div>
      </div>

      <div class="imageList">
        <div class="imageList-item">
          <div class="imageList-item-inner">
            <img src="../assets/audio.png" class="vr" @click="goPav(1)" />
            <div>展馆历史</div>
          </div>
        </div>
        <div class="imageList-item">
          <div class="imageList-item-inner">
            <img src="../assets/myvr.png" class="vr" @click="goPav(2)" />
            <div>展馆现状</div>
          </div>
        </div>
        <div class="imageList-item">
          <div class="imageList-item-inner" @click="goPav(3)">
            <img src="../assets/nav.png" />
            <div>展馆交通</div>
          </div>
        </div>
      </div>
      <div
        style="
          font-weight: 600;
          font-size: 0.18rem;
          margin-top: 0.4rem;
          margin-bottom: 0.1rem;
        "
      >
        景点信息
      </div>
      <!-- 中英文景点信息 -->
      <div class="attractions">
        <div class="att-item">
          <div class="item-1">建筑级别</div>
          <div class="item-2">优秀历史建筑、市文物保护单位</div>
        </div>
        <div class="att-item">
          <div class="item-1">建筑地址</div>
          <div class="item-2">徐汇区蒲西路166号</div>
        </div>
        <div class="att-item">
          <div class="item-1">开放时间</div>
          <div class="item-2">
            周二至周日，参观场次以“上海气象博物馆”官方微信公布为准
          </div>
        </div>
        <div class="att-item">
          <div class="item-1">门票信息</div>
          <div class="item-2">
            免费（微信公众号：徐家汇源景区、上海气象博物馆报名）
          </div>
        </div>
      </div>
      <!-- 中英文景点内容 -->
      <div class="mycontent">
        <p>蒲西路166号，原徐家汇观象台，建于1901年，建筑属于文艺复兴风格。</p>
        <p>
          徐家汇观象台创始于清同治十二年（1873年）。旧台在肇家浜畔，只是平屋数间，十分简陋，其后逐渐发展，于1899年在徐光启墓东首辟地建起新台，于1901年建成。该建筑外立面为灰色清水砖墙、圆拱券穿，窗框和窗下装饰采用红砖，局部墙身带有齿形饰，部分窗框由红砖砌筑隅石状。平台及室外楼梯采用古典式宝瓶状栏杆。
        </p>
        <img src="../assets/content1.jpg" alt="" width="100%" style="margin-bottom:0.2rem"/>
        <p>
          1872年，法国传教士在徐家汇成立观象台，12月开始气象观测。1879年，运用单站气象要素分析，首次较准确地做出台风预报，揭开上海天气预报的序幕。1895年，在这里绘制出了中国首张东亚地面天气图，作为国际知名的观测台，19世纪末，其联络网络已经北及西伯利亚，南至马尼拉，东到日本，西至印度半岛，并向中国沿海各地气象台及航海船舶发布气象消息，是当时报告航海船舶气象的中心，被誉为“远东第一气象台”。
        </p>
        <img src="../assets/content2.jpg" alt="" width="100%" style="margin-bottom:0.2rem"/>
        <p>
          2005年10月31日，上海市人民政府公布此处为上海市优秀历史建筑。2014年4月4日，由上海市人民政府公布为上海市文物保护单位。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  watch: {},
  methods: {
    goPav(id) {
      this.$router.push("/pavilion/" + id);
    },
  },
};
</script>

<style>
table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}
table td,
table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
}
table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}
blockquote {
  display: block;
  border-left: 8px solid #d0e5f2;
  padding: 5px 10px;
  margin: 10px 0;
  line-height: 1.4;
  font-size: 100%;
  background-color: #f1f1f1;
}
code {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  background-color: #f1f1f1;
  border-radius: 3px;
  padding: 3px 5px;
  margin: 0 3px;
}
pre code {
  display: block;
}
ul,
ol {
  margin: 10px 0 10px 20px;
}
.mycontent img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
}
</style>
<style scoped lang="less">
.bgimage {
  overflow: hidden;
  width: 100%;
}
.el-carousel__item img {
  position: absolute;
  bottom: 50%;
  transform: translateY(50%);
}
.hp {
  animation: myfirst 40s infinite linear;
}
@keyframes myfirst {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(1.2);
  }

  50% {
    transform: scale(1.2) translateX(-60rpx);
    /* transform: scale(1.3); */
  }

  75% {
    transform: scale(1.2) translateX(0rpx);
    /* transform: scale(1.3); */
  }

  100% {
    transform: scale(1);
  }
}
.content {
  width: 100%;
  padding: 0 0.2rem;
  box-sizing: border-box;
  position: relative;
  top: -0.34rem;
  z-index: 10;
  .name {
    background-color: #fff;
    box-shadow: 0 0 10px rgba(35, 35, 35, 0.3);
    padding: 0.15rem 0.2rem;
    box-sizing: border-box;
    border-radius: 0.06rem;
    word-wrap: break-word;
    .name1 {
      font-size: 0.26rem;
      color: #000000;
      font-weight: 900;
      line-height: 0.42rem;
    }
    .name2 {
      font-size: 0.2rem;
      color: #000000;
      font-weight: 400;
      line-height: 0.26rem;
    }
  }
  .imageList {
    width: 100%;
    display: flex;
    color: #a78d60;
    box-sizing: border-box;
    padding: 0 0.1rem;
    margin-top: 0.3rem;
    .imageList-item {
      width: 33%;
      .imageList-item-inner {
        width: 1rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        img {
          width: 0.5rem;
          height: 0.5rem;
        }
        div {
          width: 1.3rem;
          font-size: 0.15rem;
          margin-top: 0.05rem;
          text-align: center;
        }
      }
    }
  }
  .imageList div:nth-child(2) {
    display: flex;
    justify-content: center;
  }

  .imageList div:nth-child(3) {
    display: flex;
    justify-content: flex-end;
  }
  .zh-en {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 0.2rem;
    .zh-en-active {
      border-top-left-radius: 0.15rem;
      border-bottom-left-radius: 0.15rem;
      width: 0.45rem;
      line-height: 0.28rem;
      text-align: center;
      background-color: #a78d60;
      color: #fff;
    }
    .noactive {
      border-top-right-radius: 0.15rem;
      border-bottom-right-radius: 0.15rem;
      width: 0.45rem;
      line-height: 0.28rem;
      text-align: center;
      background-color: #f1f1f1;
      color: #cbcbcb;
    }
    .zh-en-active1 {
      border-top-right-radius: 0.15rem;
      border-bottom-right-radius: 0.15rem;
      width: 0.45rem;
      line-height: 0.28rem;
      text-align: center;
      background-color: #a78d60;
      color: #fff;
    }

    .noactive1 {
      border-top-left-radius: 0.15rem;
      border-bottom-left-radius: 0.15rem;
      width: 0.45rem;
      line-height: 0.28rem;
      text-align: center;
      background-color: #f1f1f1;
      color: #cbcbcb;
    }
  }
  .attractions {
    width: 100%;
    margin-top: 0.2rem;
    margin-bottom: 0.15rem;
    .att-item {
      width: 100%;
      display: flex;
      padding: 0.05rem 0;
      font-size: 0.15rem;
      .item-1 {
        width: 25%;
        color: #878787;
        padding: 0.07rem 0;
      }

      .item-2 {
        width: 75%;
        color: #000000;
        padding: 0.07rem 0;
        border-bottom: 1px solid #e5e5e5;
      }
    }

    .att-item1 {
      width: 100%;
      display: flex;
      padding: 0.05rem 0;
      font-size: 0.14rem;
      .item-3 {
        width: 35%;
        color: #878787;
        padding: 0.07rem 0;
      }

      .item-4 {
        width: 65%;
        color: #000000;
        padding: 0.07rem 0;
        border-bottom: 1px solid #e5e5e5;
      }
    }
  }
  .figures {
    width: 100%;
    border-top: 0.1rem solid rgba(230, 225, 225, 0.4);
    .figures-tit {
      font-size: 0.2rem;
      font-weight: 700;
      color: #222222;
      line-height: 0.21rem;
      letter-spacing: 1px;
      margin-top: 0.3rem;
      margin-bottom: 0.08rem;
    }
    .figures-content {
      margin-top: 0.1rem;
      display: flex;
      overflow-x: scroll;
      .figures-item {
        flex-shrink: 0;
        margin-right: 0.2rem;
        .figures-image {
          border-radius: 50%;
          width: 0.6rem;
          height: 0.6rem;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .figures-name {
          width: 0.6rem;
          text-align: center;
          margin-top: 0.05rem;
        }
      }
    }
  }
  .video {
    position: relative;
    width: 100%;
    height: 2rem;
    margin-top: 0.3rem;
    .myvideoimg {
      background-color: rgba(0, 0, 0, 0.7);
      /* opacity: 0.6; */
      width: 100%;
      height: 100%;
      z-index: 1;
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.2rem;
      }
    }
    video {
      object-fit: cover;
      width: 100%;
      height: 2rem;
    }
  }

  .mycontent {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 0.1rem solid rgba(230, 225, 225, 0.4);
    p {
      line-height: 0.3rem;
      text-align:justify;
      margin-bottom: 0.2rem;
    }
  }
}
.paudio {
  width: 100%;
  position: fixed;
  max-width: 768px;
  bottom: 0;
  left: 0;
  background-color: #a78d60;
  border-radius: 0.15rem 0.15rem 0px 0px;
  padding: 0.2rem 0.2rem;
  box-sizing: border-box;
  color: #fff;
  z-index: 100;
  .paudio-tit {
    font-size: 0.2rem;
    width: 100%;
    font-weight: 600;
    margin-top: 0.2rem;
    margin-bottom: 0.15rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      width: 0.2rem;
      height: 0.2rem;
    }
  }

  .paudio-content {
    max-height: 2rem;
    overflow-y: scroll;
    .paudio-item {
      width: 100%;
      margin: 0 auto;
      font-size: 0.15rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 0.4rem;
      .paudio-item-name {
        width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .active {
        color: #fff;
      }
      .noactive {
        color: #eeddbe;
      }

      img {
        width: 0.2rem;
        height: 0.2rem;
      }
    }
  }
}
.goapp {
  width: 0.65rem;
  width: 0.65rem;
  position: fixed;
  max-width: 768px;
  right: 0.2rem;
  bottom: 0.3rem;
  z-index: 10;
}
</style>